<template>
  <div class="sc-message--slide">
    <div
      v-for="(content, index) in data.text"
      :key="content.label"
      class="sc-message--slide-page"
    >
      <!--<transition name="fade"> -->
      <div v-if="index == currentPage">
        <div
          v-if="content.image"
          class="sc-message--slide-img"
        >
          <div class="sc-message--slide-navigation">
            <div
              class="sc-message--slide-left"
            >
              <img
                class="sc-message--slide-arrow-icon"
                src="@/assets/img/arrow-slider-left.png"
                @click="clickLeft()"
              >
            </div>
            <div
              class="sc-message--slide-right"
            >
              <img
                class="sc-message--slide-arrow-icon"
                src="@/assets/img/arrow-slider-right.png"
                @click="clickRight()"
              >
            </div>
            <div class="sc-message--slide-slideshow">
              <!--TARJETAS-->
              <ul class="sc-message--slide-slideshow-ul">
                <li class="sc-message--slide-slideshow-li">
                  <div
                    v-if="content.image && content.clickeable_img"
                    v-touch:swipe="swipeHandler"
                    class="sc-message--slide-slideshow-body clickeable-image"
                  >
                    <img
                      v-if="content.image && content.clickeable_img"
                      class="sc-message--slide-slideshow-img"
                      :src="content.image"
                      @click="openModalImg(content.image)"
                    >
                  </div>
                  <div
                    v-else-if="content.image"
                    v-touch:swipe="swipeHandler"
                    class="sc-message--slide-slideshow-body"
                  >
                    <img
                      class="sc-message--slide-slideshow-img"
                      :src="content.image"
                    >
                  </div>
                  <div
                    v-if="content.image && content.clickeable_img"
                    class="sc-message--slide-icon-footer"
                    @click="openModalImg(content.image)"
                  >
                    <img
                      src="@/assets/img/miximize-icon.png"
                      class="sc-message--slide-maximize"
                      @click="openModalImg(content.image)"
                    >
                  </div>
                </li>
              </ul>
            </div>
            <div class="sc-message--slide-pagination">
              <ol>
                <li
                  v-for="(contentPage, indexPage) in data.text"
                  :key="contentPage.label"
                >
                  <div @click="clickIndex(indexPage)">
                    <v-icon
                      :class="{ 'sc-message--slide-page-active' : indexPage === currentPage }"
                      name="circle"
                      scale="0.5"
                    />
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div class="sc-message--slide-content">
          <div v-if="!content.image">
            <div
              class="sc-message--slide-left-no-image"
              @click="clickLeft()"
            >
              <v-icon
                name="chevron-left"
                scale="1.3"
              />
            </div>

            <div
              class="sc-message--slide-right-no-image"
              @click="clickRight()"
            >
              <v-icon
                name="chevron-right"
                scale="1.3"
              />
            </div>

            <div class="sc-message--slide-pagination-no-image">
              <ol>
                <li
                  v-for="(contentPage, indexPage) in data.text"
                  :key="contentPage.label"
                >
                  <div @click="clickIndex(indexPage)">
                    <v-icon
                      :class="{ 'sc-message--slide-page-active' : indexPage === currentPage }"
                      name="circle"
                      scale="0.5"
                    />
                  </div>
                </li>
              </ol>
            </div>
          </div>

          <div
            v-if="content.title"
            class="sc-message--slide-title"
          >
            {{ content.title }}
          </div>
          <div
            v-if="content.text"
            class="sc-message--slide-text"
            v-html="content.text"
          />
          <ul class="sc-message--slide-control">
            <hr class="sc-message--slide-hr">
            <li
              v-for="(btn) in content.buttons"
              :key="btn.label"
              class="sc-message--slide-control-item"
            >
              <a
                :disabled="!canClickButton"
                @click="clickButton($event,btn)"
              >{{ btn.label }}</a>
              <hr class="sc-message--slide-hr">
            </li>
          </ul>
        </div>
      </div>
      <!--</transition>-->
    </div>
  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/chevron-left'
import 'vue-awesome/icons/chevron-right'
import 'vue-awesome/icons/circle'
import 'vue-awesome/icons/eye'
import { serverUI } from './main'

export default {
  components: {
    'v-icon': Icon
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 0
    }
  },
  computed: {
    canClickButton () {
      return this.data.text[0].processClick
    }
  },
  methods: {
    openModalImg (urlImg) {
      const w = window.innerWidth
      if (w > 450) {
        serverUI.$emit('updateModalImg', urlImg)
      }
    },
    swipeHandler (direction) {
      if (direction === 'left') {
        this.clickLeft()
      }
      if (direction === 'right') {
        this.clickRight()
      }
    },
    clickButton (event, btn) {
      if (this.data.text[0].processClick) {
        if (!event.target.classList.contains('sc-message--slide-button-bg')) {
          event.target.classList.toggle('sc-message--slide-button-bg')
        }
        btn.event(btn)
      }
    },
    clickLeft () {
      this.currentPage--
      if (this.currentPage < 0) this.currentPage = this.data.text.length - 1
    },
    clickRight () {
      this.currentPage++
      if (this.currentPage >= this.data.text.length) this.currentPage = 0
    },
    clickIndex (index) {
      this.currentPage = index
    }
  }
}
</script>
<style scoped>
.sc-message--slide {
    margin: 0;
    padding: 0;
    outline: none;
    display: block;
}

.sc-message--slide-page {
    border-radius: 15px 15px 0 0;
}

.sc-message--slide-page-active {
    color: #02afb9;
}

.sc-message--slide-navigation {
    background-color: #eaeded;
    border-radius: 15px 15px 0 0;
    width: 100%;
}

.sc-message--slide-slideshow {
    width: calc(100% - 60px);
    position: relative;
    top: -30px;
    left: 30px;
}

.sc-message--slide-slideshow-ul {
    margin: 0;
    padding: 0;
    list-style: none;
}

.sc-message--slide-slideshow-li {
    display: list-item;
    text-align: -webkit-match-parent;
    list-style: none;
    background-color: white;
    margin-top: 20px;
    border-radius: 15px 15px 15px 15px;
}

.sc-message--slide-slideshow-body {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: auto;
}

.sc-message--slide-slideshow-img {
    width: 100%;
    border-radius: 10px 10px 10px 10px;
}

.sc-message--slide-slideshow-img::selection {
    background: transparent;
}

.sc-message--slide-pagination {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
    outline: none;
    top: -20px;
}

.sc-message--slide-pagination ol {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
    outline: none;
}

.sc-message--slide-pagination li {
    font-size: 8px;
    margin: 0 0 0 -3px;
    color: #b1b0b1;
    cursor: pointer;
}

.sc-message--slide-pagination-no-image {
    position: relative;
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
    outline: none;
    top: -20px;
}

.sc-message--slide-pagination-no-image ol {
    position: relative;
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0;
    outline: none;
    top: 10px;
}

.sc-message--slide-pagination-no-image li {
    font-size: 8px;
    margin: 0 10px 0 -3px;
    color: #b1b0b1;
    cursor: pointer;
}

.sc-message--slide-left {
    left: 7px;
    top: 90px;
    position: relative;
    padding-top: 0;
    display: inline;
    align-items: center;
    color: #4067aa;
    font-size: 15px;
    cursor: pointer;
}

.sc-message--slide-left-no-image {
    left: 15px;
    top: 10px;
    position: relative;
    padding-top: 0;
    display: inline;
    align-items: center;
    color: #4067aa;
    font-size: 15px;
    cursor: pointer;
}

.sc-message--slide-right {
    left: calc(100% - 43px);
    top: 90px;
    position: relative;
    padding-top: 0;
    display: inline;
    align-items: center;
    color: #4067aa;
    font-size: 15px;
    cursor: pointer;
}

.sc-message--slide-right-no-image {
    left: calc(100% - 43px);
    top: 10px;
    position: relative;
    padding-top: 0;
    display: inline;
    align-items: center;
    color: #4067aa;
    font-size: 15px;
    cursor: pointer;
}

.sc-message--slide-content {
    position: static;
    width: 100%;
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
    outline: none;
}

.sc-message--slide-title {
    list-style-type: none;
    color: #336195;
    font-size: 15px;
    margin: 13px 10px 5px 10px;
    font-weight: bold;
}

.sc-message--slide-text {
    font-size: 13px;
    color: grey;
    margin: 3px 0 3px 10px;
}

.sc-message--slide-hr {
    height: 1px;
    border: 0;
    background-color: #d8d9da;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
}

.sc-message--slide-control {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.sc-message--slide-control-item {
    color: #00acba;
    font-size: 14px;
    line-height: 2em;
    cursor: pointer;
}

.sc-message--slide-control-item a {
    display: block;
    padding: 1px 0;
    text-decoration: none;
    padding-left: 10px;
    font-size: 14px;
    color: #4067aa;
    background-color: #fff;
}

.sc-message--slide-control-item a:hover {
    color: #fff;
    background-color: #4067aa;
}

.sc-message--slide-button-bg {
    color: white;
    background-color: rgb(50, 98, 149);
}

.sc-message--slide-button:hover {
    text-decoration: underline;
    transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -moz-transition-duration: 0.2s;
    text-decoration: none;
}

.sc-message--slide-navigation .fa-icon {
    width: 16px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
{
    opacity: 0;
}
.clickeable-image img { display: flex; }

.sc-message--slide-arrow-icon {
  width: 6.5%;
}

.sc-message--slide-maximize {
  width: auto;
  height: 90%;
  margin: 1px 3px 0px 0px;
}

.sc-message--slide-icon-footer {
  width: 100%;
  height: 28px;
  background-color: #CCCCCC;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
